import React, {useEffect} from 'react';
import ChoiceStep from "../models/course/choice-step";
import newCourseService from "../services/course_service";
import CourseContext from "../context/courseContext";
import courseTracking from "../services/course-tracking";
import userService from "../services/user";
import ReactPlayer from "react-player";
import ConfirmDialog from "../components/confirmDialog";
import AdminControls from "../components/adminControls";
import VideoStep from "../models/course/video-step";
import AudioStep from "../models/course/audio-step";
import {trackCustomEvent} from "gatsby-plugin-google-analytics";
import googleAnalyticsTracking from "../services/google-analytics-tracking";
import * as queryString from "querystring";
import withLocation from "./withLocation";
import { navigate } from "gatsby"
import alertService from "../services/alert";
import {Alert, AlertType} from "../models/alert";


/*
* Determines the defaults section based on app_type and currentUser position but can be overwritten by component props
 */
const determineDefaults = (props) => {

    if(props.adminOverview){
        return {
            ...props
        }
    }
    let defaultSection;
    if(userService.currentUser?.app_type == "your_move"){
        if(userService.currentUser.position !== null && userService.currentUser.position != "jessica"  && userService.currentUser.position != "openpreview"  && userService.currentUser.position != "open") {
            defaultSection = newCourseService.sections[userService.currentUser.position]
            if(userService.currentUser.upcomingClose){
                defaultSection.redirect = userService.currentUser.upcomingClose
            }
        }
        else {
            defaultSection = newCourseService.sections.lessons;
        }
    } else {
        defaultSection = newCourseService.sections.open
        if(userService.currentUser?.position && ((userService.currentUser.position == "jessica" && userService.currentUser.current_key != "opening") || userService.currentUser.position != "jessica")) {
            defaultSection = newCourseService.sections[userService.currentUser.position]
        }
        else if(userService.currentUser?.jessicas_room) {
            defaultSection = newCourseService.sections.welcomeBack
        }
    }



    let defaultSequenceKey = userService.currentUser?.current_key
                                && userService.currentUser.position != "openpreview"
                                && typeof newCourseService.sections[userService.currentUser.position].sequences != "undefined"
                                && typeof newCourseService.sections[userService.currentUser.position].sequences[userService.currentUser.current_key] != "undefined"
                                ? userService.currentUser.current_key  : "opening";
    //allow overriding the default sequence for Jessica's room menu item
    const { sequence } = props.search;
    if(sequence) defaultSequenceKey = sequence;
    const defaultStepIndex =
        typeof userService.currentUser != "undefined" && typeof defaultSection != "undefined"
            ?  newCourseService.getStepIndex(defaultSection.key,defaultSequenceKey, userService.currentUser?.current_file)
            : 0;

    const defaultStartTime = userService.getStartTime();
    //console.log("Default PROPs:", props);

    return {
        section: defaultSection,
        sequenceKey: defaultSequenceKey,
        stepIndex:  defaultStepIndex,
        startTime: defaultStartTime,
        ...props //here we're able to override the defaults with by spreading props
    };
}

const CourseHOC = (props) => {
    //console.log("props",props);
    const defaults = determineDefaults(props);
    if (typeof defaults.section == "undefined" ){
        if(userService.currentUser?.app_type == "your_move") {
            defaults.section = newCourseService.sections.lessons;
        }
        else {
            defaults.section = newCourseService.sections.open;
        }
        console.warn("default section undefined", defaults);
    }
    //if somehow the sequenceKey doesn't appear in the section (ie the user position data was saved incorrectly), default to opening
    if (typeof defaults.section == "undefined" || typeof defaults.section.sequences[defaults.sequenceKey] == "undefined") {
        defaults.sequenceKey = "opening";
        console.warn("default sequences undefined", defaults);
    }

    // console.log("user:", userService.currentUser);
    // console.log("Default:", defaults);
    const [data, setData] = React.useState({
        open:false,
        currentSection: defaults.section,
        currentSequence: defaults.section.sequences[defaults.sequenceKey],
        currentStep: defaults.section.sequences[defaults.sequenceKey].steps[defaults.stepIndex],
        nextStep: null,
        currentStepIndex: defaults.stepIndex,
        openingHasPlayed: false,
        totalSteps: defaults.section.sequences[defaults.sequenceKey].steps.length,
        currentSequenceKey: "opening",
        previousSequenceKey: "",
        showOverlayChoices: false,
        startTime: defaults.defaultStartTime,
    });
    let defaultCountdown = 180;
    if(data.currentSequence.countdownTime) {
        defaultCountdown = data.currentSequence.countdownTime;
    }
    const [seconds, setSeconds] = React.useState(defaultCountdown);
    const [timerIsActive, setTimerIsActive] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [playing, setPlaying] = React.useState(false);
    const [internalPlayer, setInternalPlayer] = React.useState();
    function toggleTimer() {
        setTimerIsActive(!timerIsActive);
    }

    function resetTimer() {
        setSeconds(defaultCountdown);
        setTimerIsActive(false);
    }
    useEffect(() => {
        let isMounted = true; // note this flag denote mount status
        let interval;
        if (timerIsActive) {
            interval = setInterval(() => {
                setSeconds(seconds => seconds - 1);
                if(seconds <= 0 && isMounted) {
                    //console.log("You've served you're time");
                    resetTimer();
                }
            }, 1000);
        } else if (interval && !timerIsActive && seconds !== 0) {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
            isMounted = false
        };
    }, [timerIsActive, seconds]);

    const getNextStep = () => {
        if(data.currentStepIndex + 1 >= data.totalSteps) {
            if(data.currentSequence.redirect == "opening") { //TODO - find a better way
                return data.currentSection.sequences['opening'].steps[0];
            } else {
                if(data.currentSequence.redirectView) {
                    return newCourseService.sections[data.currentSequence.redirect].sequences["opening"].steps[0];
                } else if(data.currentSequence.redirect != null) {
                    return data.currentSection.sequences[data.currentSequence.redirect].steps[0];
                }
            }
        } else {
            return data.currentSequence.steps[data.currentStepIndex + 1]
        }
    }

    const maybeTrackLessonEnd = () => {
        if(data.currentSequence.lessonEnd) {
            courseTracking.trackLessonEnd();
        }
    }
    const loadNextStep = (args = {action:"default"}) => { //TODO - refactor this. it's gotten kinda hairy
        //possible next steps
            //next sequential video/choice step
            //next section as noted in data.currentSection.redirect (TODO - is this actually being used?)
            //next section as noted in data.currentSequence.redirect. Will also have data.currentSequence.redirectView = true (artifact of old system probably not needed anymore)
            //next section as noted
            //setNextRedirect can be used to override currentSequence.redirect in LoadSection in cases where the same sequence is used in different context

        let newData = {...data};

        if(userService.currentUser && !userService.currentUser.is_active){
            console.log(userService.currentUser);
            alert("That's the end of the preview. Please add an activation code");
            alertService.clear('log-in');
            alertService.clear('registration');
            alertService.hide();
            alertService.push(new Alert("Please add an activation code to continue using the app.", 'preview', AlertType.Error));

            navigate('/license/');
        }
        else if(data.currentSequence.redirect == "login"){
            alert("That's the end of the preview. Please login.");
            navigate("/login");
        }
        else if(data.currentStep instanceof ChoiceStep && data.currentStep.options.length > 1) {
            alert("Make a Choice");
        }
        else if(data.currentStepIndex + 1 >= data.currentSequence.steps.length) {
            if(data.currentSequence.redirect == "opening") { //TODO - find a better way
                loadOpeningSequence();
                maybeTrackLessonEnd();
            }
            else {
                //TODO check sequence exists or some other validation above
                if(data.currentSequence.redirectView) {
                    maybeTrackLessonEnd();
                    loadSection(data.currentSequence.redirect);
                } else if(data.currentSequence.redirect != null) {
                    maybeTrackLessonEnd();
                    handleLoadSequence(data.currentSequence.redirect);
                } else if (data.currentSection.redirect != null ) {
                    //console.log(data.currentSection.redirect)
                    maybeTrackLessonEnd();
                    loadSection(data.currentSection.redirect);
                    // alert("Go To Closing")
                    // handleClose();
                }
            }
        }
        else {
            newData.currentStepIndex++;
            newData.currentStep = newData.currentSequence.steps[newData.currentStepIndex];
            newData.showOverlayChoices = false;

            if(typeof newData.currentStep.backgroundImage != "undefined"){
                // console.log(require("../../images/menus/"+newData.currentStep.backgroundImage)) //TODO - maybe transition with this bg img
            }

            //if we're clicking a cog "Your Move" choice when it is overlayed on top of video we skip over the cog actual next step.
            //TODO - decide if this is the way
            //...or if we should just provide destinationKeys for the the cog choice rather then assume they all goto the next sequential step.
            if(newData.currentStep instanceof ChoiceStep && newData.currentStep.key.includes("cog") && args.action != "nextBtn") {
                courseTracking.trackStep(newData.currentStep);
                googleAnalyticsTracking.trackPageView(newData.currentSection, newData.currentSequence, newData.currentStep);

                newData.currentStepIndex++;
                newData.currentStep = newData.currentSequence.steps[newData.currentStepIndex];
            }
            else if (newData.currentStep instanceof ChoiceStep) {
                courseTracking.trackStep(newData.currentStep);
                googleAnalyticsTracking.trackPageView(newData.currentSection, newData.currentSequence, newData.currentStep);

            }

            setData(newData);
        }
    };

    const loadPrevStep = () => { //this isn't really being used....but would be nice addition
        let newData = {...data};

        if(data.currentStepIndex == 0) {
            if(data.previousSequenceKey != null) {
                let lastStepIndex = props.section.sequences[data.previousSequenceKey].steps.length - 1;
                //TODO - can cause prev sequence loop after one sequence change because it records your prev sequence (even if it was a future sequence)
                handleLoadSequence(data.previousSequenceKey,lastStepIndex);
            } else {
                alert("no previous sequence");
            }
        } else {
            newData.showOverlayChoices = false;
            newData.currentStepIndex--;
            newData.currentStep = newData.currentSequence.steps[newData.currentStepIndex];
            setData(newData);
        }
    };
    const setOverlayChoices = (shouldShow:boolean) => {
        const newData = {...data};
        newData.showOverlayChoices = shouldShow;
        setData(newData);
    }
    const onVideoEnded = () => {
        //data.currentStep.hasBeenPlayed = true;
        //TODO - record video has been played
        let ns = getNextStep();
        if(ns instanceof ChoiceStep && ns.allowOverlay){
            //pause and let them make a choice over the current step video
            googleAnalyticsTracking.trackPageView(data.currentSection, data.currentSequence, ns);
            setOverlayChoices(true);
        } else {
            loadNextStep();
        }
    };

    let currentCheck = 0;
    const onVideoProgress = (e) => {
        let roundedTime = Math.floor(e.playedSeconds);

        if(roundedTime % 5 === 0 && currentCheck !== roundedTime) {
            currentCheck = roundedTime;
            let mediaSource;
            if(data.currentStep instanceof VideoStep) {
                mediaSource = data.currentStep.video.src;
            } else if(data.currentStep instanceof AudioStep) {
                mediaSource = data.currentStep.audio.src;
            }
            courseTracking.trackVideoProgress(data.currentSection.key, data.currentSequenceKey, mediaSource, roundedTime)
        }
    }

    const onVideoReady = (videoPlayerState, nativePlayer) => {
        // console.log("onVideoReady");
        // console.log(nativePlayer.src)
        setInternalPlayer(nativePlayer);
        if(typeof userService.currentUser?.current_file_time != "undefined"
            && nativePlayer.src == userService.currentUser?.current_file
            && nativePlayer.currentTime < userService.currentUser?.current_file_time - 5
            && !videoPlayerState.hadSeeked
            && !videoPlayerState.justTracked) {

            //hasLoaded = true;
            setConfirmOpen(true);
            // if (confirm("Would you like to Resume?")) {
            //     nativePlayer.currentTime = userService.currentUser?.current_file_time
            // }
        } else {
            nativePlayer.play();
        }
    }

    const resumeVideo = () => {
        if(typeof internalPlayer != "undefined") {
            internalPlayer.currentTime = userService.currentUser?.current_file_time
            internalPlayer.play();
        }
    }

    const onReturnFromVideo = () => {
        if(userService.currentUser?.app_type == "seventeen_days") {
            loadSection('jessica', 'opening', 0);
        } else {
            loadSection('lessons', 'opening', 0);
        }
    }

    const handleLoadSequence = (sequenceKey:string, stepIndex: number = 0) => {
        let newData = {...data};
        newData.showOverlayChoices = false;
        newData.currentStepIndex = stepIndex;
        newData.currentSequenceKey = sequenceKey;
        newData.currentSequence = data.currentSection.sequences[sequenceKey];
        newData.currentStep = data.currentSection.sequences[sequenceKey].steps[stepIndex];
        newData.totalSteps = data.currentSection.sequences[sequenceKey].steps.length;
        newData.previousSequenceKey = data.currentSequenceKey;
       // console.log(newData.currentStep)

        courseTracking.trackSequence(newData.currentSequence)
        googleAnalyticsTracking.trackPageView(newData.currentSection, newData.currentSequence, newData.currentStep);

        setData(newData);
    }

    const loadSection = (sectionKey:string, sequenceKey:string = "opening", stepIndex: number = 0) => {
        let newData = {...data};

        newData.showOverlayChoices = false;
        newData.currentSection = newCourseService.sections[sectionKey];
        newData.currentStepIndex = stepIndex;
        newData.currentSequenceKey = sequenceKey;
        newData.currentSequence =  newCourseService.sections[sectionKey].sequences[sequenceKey];

        if(typeof data.currentSequence.setNextRedirect == "string") {
            newData.currentSection.redirect = data.currentSequence.setNextRedirect;
            newData.currentSequence.setNextRedirect = data.currentSequence.setNextRedirect;
            if(userService.currentUser)
                userService.currentUser.upcomingClose = data.currentSequence.setNextRedirect;
        }

        if(data.currentSequence.countdownTime > 0) {
            setSeconds(data.currentSequence.countdownTime);
            setTimerIsActive(true);
        }
        newData.currentStep =  newCourseService.sections[sectionKey].sequences[sequenceKey].steps[stepIndex];
        newData.totalSteps =  newCourseService.sections[sectionKey].sequences[sequenceKey].steps.length;
        newData.previousSequenceKey = data.currentSequenceKey;
        //window.history.pushState({page:"fake"}, newCourseService.sections[sectionKey].sequences[sequenceKey].label, "/" + sectionKey); //TODO - is this the best way? This fakes a route change without reloading
        courseTracking.trackSequence(newData.currentSequence);
        courseTracking.updateUserPosition(sectionKey, sequenceKey);
        googleAnalyticsTracking.trackPageView(newData.currentSection, newData.currentSequence, newData.currentStep);
        setPageView(sectionKey, sequenceKey);
        setData(newData);
    }

    const loadOpeningSequence = () => {
        //console.log("loadOpeningSequence")
        let newData = {...data};
        newData.showOverlayChoices = false;
        newData.currentSection = data.currentSection;
        newData.currentSequence = data.currentSection.sequences['opening'];
        newData.currentStepIndex = 0;
        newData.currentStep = data.currentSection.sequences['opening'].steps[0];
        newData.totalSteps = data.currentSection.sequences['opening'].steps.length;
        newData.previousSequenceKey = "";
        setData(newData);
    }

    const setPageView = (section, step) => {
        if (typeof window !== 'undefined') {
            //window.location.href =+ section + "/" + step;
            window.history.pushState('html', 'Title',  "#" + section + "/" + step);
            // window.ga('set', 'page', '/new-page.html');
            // window.ga('send', 'pageview');
            // trackCustomEvent({
            //     // string - required - The object that was interacted with (e.g.video)
            //     category: "Special Button",
            //     // string - required - Type of interaction (e.g. 'play')
            //     action: "Click",
            //     // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
            //     label: "Gatsby Plugin Example Campaign",
            //     // number - optional - Numeric value associated with the event. (e.g. A product ID)
            //     value: 43
            // })
        }
    }

    const handlePlayFromBeginning = () => {
        userService.clearPosition();
        loadSection('open','opening',0)
    };
    return (
        <CourseContext.Provider
            value={{
                courseState: data,
                setCourseState: setData,
                section:data.currentSection,
                sequence:data.currentSequence,
                step:data.currentStep,
                stepIndex: data.currentStepIndex,
                totalSteps: data.totalSteps,
                getNextStep: getNextStep,
                onEnded:onVideoEnded,
                onReady:onVideoReady,
                onProgress:onVideoProgress,
                startTime:defaults.startTime,
                loadPrevStep:loadPrevStep,
                loadNextStep:loadNextStep,
                handleLoadSequence:handleLoadSequence,
                handleLoadSection:loadSection,
                playFromTheBeginning: handlePlayFromBeginning,
                showOverlayChoices: data.showOverlayChoices,
                timerIsActive: timerIsActive,
                seconds: seconds,
                resetTimer: resetTimer,
                toggleTimer: toggleTimer,
                playing: playing,
                enableScrubbing: (userService.currentUser?.jessicas_room || userService.currentUser?.is_admin ? true : false)
            }}>

            {props.children}

            <ConfirmDialog
                title="Resume?"
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onDeny={() => internalPlayer.play()}
                onConfirm={resumeVideo}
                onReturn={onReturnFromVideo}
            >
                Do you want to resume where you left off?
            </ConfirmDialog>

        </CourseContext.Provider>
    );
}

// CourseHOC.defaultProps = {
//     section: userService.currentUser?.position ? newCourseService.sections[userService.currentUser.position] : newCourseService.sections.open,
//     sequenceKey: userService.currentUser?.current_key ? userService.currentUser.current_key  : "opening",
//     stepIndex: 0,
// }
export default withLocation(CourseHOC);